<template>
<v-container>
    <v-row justify="end">
        <v-btn outlined @click="$router.push(`/`)">목 록</v-btn>
    </v-row>

    <v-card class="my-3">
        <div style="background: #f5f5f5">
            <v-row class="px-4" align="end">
                <v-col style="font-size: 20px">{{ item.title }} [{{ item.replies }}]</v-col>
                <v-col class="text-right">
                    조회 {{ item.views }} | 공감 <b style="color: red">{{ item.likes }}</b> | 비공감 <b style="color: blue">{{ item.dislikes }}</b> | 신고
                </v-col>
            </v-row>
            <v-row class="px-4 pb-4" align="start" style="color: grey">
                <v-col class="py-0">{{ item.writer }}</v-col>
                <v-col class="py-0 text-right">
                    {{ new Date(item.createdAt).toLocaleString() }}
                </v-col>
            </v-row>
        </div>
        <v-divider />
        <div class="pa-4 text-right" v-if="item.writerId == user.id">
            <span style="cursor: pointer" @click="edit">수정</span>
            <span class="mx-3">|</span>
            <span style="cursor: pointer" @click="deletePost">삭제</span>
        </div>
        <div class="pa-4" v-html="item.content">
        </div>
        <div class="text-center pa-3">
            <v-btn class="mr-10" color="red" :loading="loading" @click="like(item.id)">
                <v-icon class="mr-2">thumb_up</v-icon>{{ item.likes }}
            </v-btn>
            <v-btn color="blue" :loading="loading" @click="dislike(item.id)">
                <v-icon class="mr-2">thumb_down</v-icon>{{ item.dislikes }}
            </v-btn>
        </div>
        <v-divider />
        <div class="pa-4">
            <div style="font-size: 20px">댓글 {{ item.replies }}</div>
            <v-form ref="form">
                <div class="mt-2 pa-4" style="border-radius: 10px; border: 1px solid grey">
                    <v-row class="px-4">
                        <span>{{ user.name }}</span>
                        <v-spacer />
                        <span>{{ contentCounter }}</span>
                    </v-row>
                    <v-textarea ref="content" dense v-model="content" rows="1" outlined auto-grow :rules="contentRule"></v-textarea>
                    <div class="text-right">
                        <v-btn class="pa-0 ma-0" tile color="primary" @click="writeReply">등 록</v-btn>
                    </div>
                </div>
            </v-form>
        </div>
        <v-divider />
        <div class="mx-3" v-for="(item, i) in replies" :key="item.id">
            <reply :sort="sort" :reply="item" @delete="deleteReply(i)" />
        </div>
        <div class="pa-3 text-center" style="cursor: pointer" @click="moreReplies" v-if="!noMoreItems">
            더보기
        </div>
    </v-card>
</v-container>
</template>

<script>
import firebase from 'firebase/app'
import {
    db,
    auth,
    functions
} from '@/firebase'
import Reply from '@/views/components/Reply'
import {
    AccountToast
} from '@/mixins/account-toast.js'
import {
    DateFormat
} from '@/mixins/date.js'

export default {
    components: {
        Reply
    },
    mixins: [
        AccountToast,
        DateFormat
    ],
    data: () => ({
        route: '',
        postRef: '',
        sort: '',
        item: {},
        content: '',
        contentRule: [
            v => {
                if (!v) return '내용을 입력해주세요'
                if (v.length > 300) return '300자를 넘을 수 없습니다'
                return true
            }
        ],
        replies: [],
        loading: false,
        noMoreItems: false
    }),
    computed: {
        user() {
            return this.$store.getters.user
        },
        contentCounter() {
            return `${this.content.length} / 300`
        },
    },
    created() {
        const splits = this.$route.path.split("/")
        this.route = splits[1]

        this.postRef = db.collection(this.route).doc(this.$route.params.id)

        db.runTransaction(transaction => {
            return transaction.get(this.postRef).then(doc => {
                if (!doc.exists) return

                this.item = doc.getDocument()
                transaction.update(this.postRef, {views: this.item.views + 1})
            })
        })
    },
    async mounted() {
        this.replies = await db.collection(this.route).doc(this.$route.params.id).collection("replies")
            .orderBy("createdAt", "desc").limit(5).parseCollection()

        if (this.item.replies == this.replies.length) this.noMoreItems = true
    },
    methods: {
        edit() {
            this.$router.push({
                name: 'NoticeWrite',
                params: {
                    data: this.item
                }
            })
        },
        async deletePost() {
            if (!confirm("삭제하시겠습니까?")) return

            const deleteFn = functions.httpsCallable('recursiveDelete')
            const path = db.collection(this.route).doc(this.$route.params.id).path

            await deleteFn({
                path,
                userId: this.user.id
            })

            this.$router.go(-1)
        },
        async writeReply() {
            if (!this.$store.getters.isLoggedIn) return this.showLoginToast()

            if (!this.$store.state.emailVerified) return this.showVerifyToast()

            if (!this.$refs.form.validate()) return

            const reply = {
                content: this.content,
                createdAt: Date.now(),
                writerId: this.user.id,
                writer: this.user.name,
                replies: 0
            }

            const res = await db.collection(this.route).doc(this.$route.params.id).collection("replies").add(reply)
            db.collection(this.route).doc(this.$route.params.id).update({
                replies: firebase.firestore.FieldValue.increment(1)
            })

            reply.id = res.id
            this.replies.unshift(reply)
            this.item.replies++
            this.content = ""
            this.$refs.content.resetValidation()
        },
        deleteReply(index) {
            this.replies.splice(index, 1)
            this.item.replies--
            db.collection(this.route).doc(this.$route.params.id).update({
                replies: firebase.firestore.FieldValue.increment(-1)
            })
        },
        async moreReplies() {
            const lastItem = this.replies[this.replies.length - 1]
            const newItems = await db.collection(this.route).doc(this.$route.params.id).collection("replies")
                .orderBy("createdAt", "desc").startAfter(lastItem).limit(1).getDocs()

            for (const newItem of newItems) this.replies.push(newItem)

            if (this.item.replies == this.replies.length) this.noMoreItems = true
        },
        async like(id) {
            if (!this.$store.getters.isLoggedIn) return this.showLoginToast()

            if (!this.$store.state.emailVerified) return this.showVerifyToast()

            if (!this.user.likedPost) this.user.likedPost = []
            if (!this.user.dislikedPost) this.user.dislikedPost = []

            if (this.user.likedPost.includes(id)) {
                return this.$toasted.show("이미 공감을 눌렀습니다")
            }

            if (this.user.dislikedPost.includes(id)) {
                return this.$toasted.show("이미 비공감을 눌렀습니다")
            }

            const batch = db.batch()
            batch.update(this.postRef, {likes: ++this.item.likes})
            batch.update(db.collection("users").doc(this.user.id), {
                "likedPost": firebase.firestore.FieldValue.arrayUnion(this.item.id)
            })
            await batch.commit()
        },
        async dislike(id) {
            if (!this.$store.getters.isLoggedIn) return this.showLoginToast()

            if (!this.$store.state.emailVerified) return this.showVerifyToast()

            if (!this.user.likedPost) this.user.likedPost = []
            if (!this.user.dislikedPost) this.user.dislikedPost = []

            if (this.user.likedPost.includes(id)) {
                return this.$toasted.show("이미 공감을 눌렀습니다")
            }

            if (this.user.dislikedPost.includes(id)) {
                return this.$toasted.show("이미 비공감을 눌렀습니다")
            }

            const batch = db.batch()
            batch.update(this.postRef, {"dislikes": ++this.item.dislikes})
            batch.update(db.collection("users").doc(this.user.id), {
                "dislikedPost": firebase.firestore.FieldValue.arrayUnion(this.item.id)
            })

            await batch.commit()
        },
        back() {
            this.$router.go(-1)
        }
    }
}
</script>

<style>
.primary-divider {
    background: #3498db;
    width: 250px;
    height: 5px
}
</style>
